import { JsonObject, JsonProperty } from 'json2typescript';
import { Pagination } from '../shared/pagination-model';

@JsonObject('SupplierFilters')
export class SupplierFilters extends Pagination {
  @JsonProperty('code', String, true) code: string = undefined;
}
